export const AUTOSAVE_ENABLED_KEY = 'wallforming-projects-autosave-enabled';
export const AUTOSAVE_DELAY_MS = 5000;
